import { TApplicationState } from '../../types/redux';

export function isFloorPlanOpened(state: TApplicationState) {
  return state.floorPlan.isOpened;
}
